import { h } from './dom.ts';

/** True inside the iOS app's WKWebView, where Google refuses embedded sign-in (ADR-0017). */
export function inNativeShell(g: object = globalThis): boolean {
  const n = g as { CAMPFIRE_TEXT?: unknown; webkit?: { messageHandlers?: unknown } };
  return n.CAMPFIRE_TEXT !== undefined || n.webkit?.messageHandlers !== undefined;
}

interface Me {
  google: boolean;
  user: { name: string; givenName: string; picture: string } | null;
}

/**
 * Sign-in strip for the join screen: a "Sign in with Google" link when the host offers it, or
 * "Signed in as <name> · Sign out". Guests are unaffected. Calls `onUser` with the given name.
 */
export function signInStrip(onUser: (givenName: string) => void): HTMLElement {
  const box = h('div.signin', { 'data-testid': 'signin', hidden: true });
  // The iOS app signs in through the system sheet (FR-AUTH-15) when its build offers the bridge.
  const native = (globalThis as { webkit?: { messageHandlers?: { signIn?: { postMessage(m: unknown): void } } } }).webkit?.messageHandlers?.signIn;
  if (inNativeShell() && !native) return box;
  void fetch('/api/me', { cache: 'no-store' })
    .then((r) => (r.ok ? (r.json() as Promise<Me>) : null))
    .then((me) => {
      if (!me?.google) return;
      box.hidden = false;
      if (me.user) {
        onUser(me.user.givenName);
        box.replaceChildren(
          h('span', { 'data-testid': 'signed-in' }, `Signed in as ${me.user.name} · `),
          h('button.link', { 'data-testid': 'sign-out', onclick: () => void fetch('/auth/logout', { method: 'POST' }).finally(() => location.reload()) }, 'Sign out'),
        );
      } else {
        const ret = encodeURIComponent(location.pathname + location.search);
        box.replaceChildren(
          native
            ? h('button', { 'data-testid': 'sign-in-google', onclick: () => native.postMessage({ return: location.pathname + location.search }) }, 'Sign in with Google')
            : h('a.button', { 'data-testid': 'sign-in-google', href: `/auth/google?return=${ret}` }, 'Sign in with Google'),
        );
      }
    })
    .catch(() => {});
  return box;
}
